import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Phone, PhoneOff } from 'lucide-react';
import { Avatar } from '../../components/ui';
import { getSocket } from '../../lib/gateway';
import { startRingtone } from '../../lib/notifications';
import { joinVoice, useVoice } from '../../lib/voice';
import { actions, privateChannelName, useStore } from '../../store/store';

export function IncomingCall() {
  const navigate = useNavigate();
  const ringing = useStore((s) => s.ringing);
  const caller = useStore((s) => (ringing ? s.users[ringing.callerId] : undefined));
  const channel = useStore((s) => (ringing ? s.channels[ringing.channelId] : undefined));
  const inThisCall = useVoice((v) => v.channelId === ringing?.channelId);
  const dnd = useStore((s) => s.me?.status === 'dnd');
  const blocked = useStore((s) => (ringing ? s.relationships[ringing.callerId]?.type === 'blocked' : false));

  useEffect(() => {
    if (!ringing || inThisCall || dnd || blocked) return;
    return startRingtone();
  }, [ringing, inThisCall, dnd, blocked]);

  useEffect(() => {
    if (inThisCall && ringing) actions.setRinging(null);
  }, [inThisCall, ringing]);

  if (!ringing || inThisCall || blocked) return null;
  const decline = () => {
    getSocket()?.emit('call:decline', { channelId: ringing.channelId });
    actions.setRinging(null);
  };
  const accept = () => {
    actions.setRinging(null);
    navigate(`/app/@me/${ringing.channelId}`);
    void joinVoice(ringing.channelId);
  };
  return (
    <div role="alertdialog" aria-label="Incoming call" className="animate-pop fixed left-1/2 top-6 z-[85] flex w-[calc(100vw-32px)] max-w-sm -translate-x-1/2 items-center gap-3 rounded-2xl border border-line bg-overlay p-4 shadow-pop">
      <Avatar user={caller} size={48} speaking />
      <div className="min-w-0 flex-1">
        <div className="truncate font-semibold text-fg">{caller?.displayName ?? 'Someone'}</div>
        <div className="truncate text-sm text-muted">{channel?.type === 'group_dm' ? `Calling ${privateChannelName(useStore.getState(), channel)}` : 'Incoming call'}</div>
      </div>
      <button type="button" onClick={decline} aria-label="Decline" className="flex size-11 items-center justify-center rounded-full bg-danger text-white hover:brightness-110">
        <PhoneOff className="size-5" />
      </button>
      <button type="button" onClick={accept} aria-label="Accept" className="flex size-11 items-center justify-center rounded-full bg-success text-white hover:brightness-110">
        <Phone className="size-5" />
      </button>
    </div>
  );
}
